function get_current_dates_and_times() {
  // get the date and time right now
  var start_moment = moment();
  // round minutes down to the nearest 30 minutes interval
  if (start_moment.minutes() < 30) {
    // minutes less than 30, round down to 0
    start_moment.minutes(0).seconds(0);
  } else {
    // minutes 30 or more, round down to 30
    start_moment.minutes(30).seconds(0);
  }
  // add three hours to create the end date and time
  var end_moment = moment(start_moment).add(3, 'hours');

  // date and time formats
  var start_date = start_moment.format('YYYY-MM-DD');
  var start_time = start_moment.format('HH:mm');
  var end_date = end_moment.format('YYYY-MM-DD');
  var end_time = end_moment.format('HH:mm');

  // get the timezone offset and format correctly
  var offset = start_moment.utcOffset() * 60;
  // use moment to find the timezone
  var timezone = moment.tz.guess();

  // assemble array of data
  var data = {
    start_moment: start_moment,
    end_moment: end_moment,
    start_date: start_date,
    start_time: start_time,
    end_date: end_date,
    end_time: end_time,
    offset: offset,
    timezone: timezone
  }
  console.log(data);
  return data;
}

$(document).ready(function(){

  // initialize google places search
  if ($('body').hasClass('page-template-page-abm-home')) {
    autocomplete();
    initialSearchForm();

    if ($('.abm-circle-overlay-video').length) {

      const config = { threshold: [0.75] };
      const videos = document.querySelectorAll('.abm-circle-overlay-video video');

      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0.75) {
            var thisVideo = $(entry.target);
            $(thisVideo).children('source').each(function(){
              var thisSrc = $(this).attr('data-src');
              $(this).attr('src', thisSrc);
            });
            entry.target.load();
          }
        });
      }, config);

      videos.forEach(video => {
        observer.observe(video);
      });

      var playing = false;

      $('.abm-circle-overlay-video-button').on('click', function(e) {
        e.preventDefault();
        if (playing == false) {
          $('.paused', this).hide();
          $('.playing', this).show();
          $('.abm-circle-overlay-video video').trigger('play');
          playing = true;
        } else if (playing == true) {
          $('.playing', this).hide();
          $('.paused', this).show();
          $('.abm-circle-overlay-video video').trigger('pause');
          playing = false;
        }
      });

    }

  }

  // quick switch checklists
  if ($('.abm-qs-checklist').length) {
    $('.abm-qs-checklist li').each(function() {
      $(this).on('click', function() {
        $(this).toggleClass('checked');
      });
    });
  }

  // newsletter sign-up form
  if ($('#newsletter-form').length) {

    $('#newsletter-form').validate({
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      ignore: '.ignore',
      rules: {
        'newsletter-email': {
          required: true,
          email: true
        }
      },
      messages: {
        'newsletter-email': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        }
      },
      submitHandler: function(form) {
        var newsletterEmail = $('#newsletter-email').val();
        $.post(
          '/wp-content/themes/abm/subscribe.php',
          {
            email: newsletterEmail
          },
          function(results) {
            var results = $.parseJSON(results);
            console.log(results);
            if (results.status == 'success') {

              $('.abm-email-footer-form-message').text(results.message);

            } else if (results.status == 'error') {

              var body = $.parseJSON(results.last_response.body);
              var errorTitle = body.title;
              var errorDetail = body.detail;
              var httpCode = results.last_response.headers.http_code;
              console.log(httpCode, errorTitle, errorDetail);
              console.log(body);

              if (errorTitle == 'Member Exists') {
                $('.abm-email-footer-form-message').text('Thanks, but you\'re already subscribed to our mailing list!');
              } else {
                $('.abm-email-footer-form-message').text(results.message);
              }

            } else {

              $('.abm-email-footer-form-message').text('Something went wrong. Please try again?');

            }
          }
        );
      }
    });

  }

  // set start date and time for reserve buttons on featured facilities page
  if ($('body').hasClass('page-template-page-abm-featured-facilities')) {
    var dates = get_current_dates_and_times();
    var start_date_time = moment(dates.start_moment).unix() + dates.offset;
    var end_date_time = moment(dates.end_moment).unix() + dates.offset;
    var buttons = $('.abm-reserve-button');
    if (buttons) {
      $(buttons).each(function(index, button) {
        var url = new URL($(button).attr('href'));
        url.searchParams.set('startTime', start_date_time);
        url.searchParams.set('endTime', end_date_time);
        $(button).attr('href', url.href);
      });
    }
  }

  // v2 functionality starts here

  if ($('#autocomplete-form')) {
    autocomplete();
    initialSearchForm();
  }

  // open and close FAQ questions
  $('.abm2-faq-question').on('click', function() {
    $(this).parent().toggleClass('abm2-faq-active');
  });
  
  // v2 :: contact form tab switcher
  $('.abm2-contact-forms').each(function(index, group) {
    $('.abm2-contact-form-card', group).on('click', function() {
      var tab = $(this).attr('data-tab');
      $('.abm2-contact-form-card', group).removeClass('abm2-contact-form-card-active');
      $(this).addClass('abm2-contact-form-card-active');  
      $('.abm2-contact-form', group).removeClass('abm2-contact-form-active');
      $('.abm2-contact-form[data-tab="' + tab + '"]', group).addClass('abm2-contact-form-active');
    });
  });
  
  // v2 :: scroll to form based on URL parameter
  var form_id = getUrlParameter('form');
  if (form_id) {
    $('html, body').animate({
      scrollTop: $($('#contact-forms header')).offset().top,
    }, 500, 'linear');
  }
});
